import { useCurrentConsulterQuery } from '@/graphql/types'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Consultation } from '../components/Consultation'

export const Home: React.FC = () => {
  const history = useHistory()
  const { data, loading } = useCurrentConsulterQuery()
  const progressConsultation = data?.currentConsulter?.progressConsultation

  useEffect(() => {
    const id = progressConsultation?.id
    if (id) {
      history.push(`/features/qa/mild_cognitive_impairment/consultations/${id}`)
    }
  }, [progressConsultation])

  return <>{!loading && !progressConsultation && <Consultation />}</>
}
